export function BenefitsBar() {
  const items = [
    {
      title: 'Inventaire en temps réel',
      desc: 'Multi-dépôts & transferts en 1 clic.',
    },
    {
      title: 'Facturation rapide',
      desc: 'PDF, paiements, relances en un seul endroit.',
    },
    { title: 'Moins d’erreurs', desc: 'Historique et contrôles simples.' },
    {
      title: 'Mise en route < 10 min',
      desc: 'Import CSV, tutoriels & support.',
    },
  ]
  return (
    <section className='border-y bg-primary'>
      <div className='mx-auto max-w-7xl px-4 py-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6'>
        {items.map((it) => (
          <div key={it.title} className='rounded-lg border bg-background p-4'>
            <div className='font-semibold text-primary'>{it.title}</div>
            <div className='text-sm text-muted-foreground mt-1'>{it.desc}</div>
          </div>
        ))}
      </div>
    </section>
  )
}
